import { createContext } from "react";

import { RouteProps } from "../../router/IRoute";
import { NavigateFunction } from "./NavigateFunction";
import { RouteGenerators } from "./RouteGenerators";

interface IRouterContextValue {
    navigate: NavigateFunction;
    readonly routeTo: RouteGenerators;
}

const unimplementedDefaultContext: IRouterContextValue = {
    async navigate(to): Promise<void> {
        throw new Error(
            `Cannot navigate to "${to}": Router is not implemented…`,
        );
    },
    get routeTo(): RouteGenerators {
        // Generate fake routes for testing
        return new Proxy({} as RouteGenerators, {
            get: (_, prop) => () => {
                throw new Error(
                    `Cannot route to "${String(
                        prop,
                    )}": Router is not implemented…`,
                );
            },
        });
    },
};

// TODO not sure if this is the right mock/stub, but it works for now.
const unitTestDefaultContext = {
    async navigate(to: string): Promise<void> {
        console.warn(`Navigate: ${to} [fake]`);
    },
    get routeTo(): RouteGenerators {
        // Generate fake routes for testing
        return new Proxy({} as RouteGenerators, {
            get:
                (_, prop) =>
                (
                    parameters?: RouteProps,
                    hashValues?: { [key: string]: any },
                ) => {
                    const paramsPart = parameters
                        ? encodeURIComponent(JSON.stringify(parameters))
                        : false;

                    const hashPart = hashValues
                        ? encodeURIComponent(JSON.stringify(hashValues))
                        : false;

                    return `/${String(prop)}${
                        paramsPart ? `/${paramsPart}` : ""
                    }${hashPart ? `#${hashPart}` : ""}}`;
                },
        });
    },
};

export const RouterContext = createContext<IRouterContextValue>(
    typeof jest === "undefined"
        ? unimplementedDefaultContext
        : unitTestDefaultContext,
);
